"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPlaceholderPosition = exports.getParentId = exports.getLastElementId = exports.getFirstElementId = exports.getElementLinks = exports.getCanDrop = exports.getAdjustedTree = void 0;
var _reselect = require("reselect");
var _omit2 = _interopRequireDefault(require("lodash/omit"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _last2 = _interopRequireDefault(require("lodash/last"));
var _filter2 = _interopRequireDefault(require("lodash/filter"));
var _isArray2 = _interopRequireDefault(require("lodash/isArray"));
var _findKey2 = _interopRequireDefault(require("lodash/findKey"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var getRootId = function getRootId(state) {
  return state.tree.id;
};
var getTree = function getTree(state) {
  return state.tree;
};
var getHoveredElement = function getHoveredElement(state) {
  return state.hoveredElement;
};
var getDraggedElement = function getDraggedElement(state) {
  return state.draggedElement;
};
var getDraggedElementId = function getDraggedElementId(state) {
  return state.draggedElement ? state.draggedElement.id : 0;
};
var getCollapsedElements = function getCollapsedElements(state) {
  return state.collapsedElements;
};
var getElementLinks = exports.getElementLinks = (0, _reselect.createSelector)(getTree, getDraggedElementId, getCollapsedElements, function (tree, draggedElementId) {
  var collapsedElements = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  if ((0, _isEmpty2["default"])(tree) || !tree.children || tree.children.length === 0) {
    return {};
  }
  var links = {};
  var aboveElement = null;
  function ignoreDraggedElement(element) {
    if (collapsedElements.includes(element.id)) {
      return null;
    }
    var children = element.children;
    if (!(0, _isArray2["default"])(children)) {
      return null;
    }
    return (0, _filter2["default"])(children, function (child) {
      return child.id !== draggedElementId;
    });
  }
  function setLinks(element) {
    var prevParents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var siblings = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    var elementId = element.id;
    links[elementId] = {
      type: element.type,
      isChildAllowed: element.isChildAllowed,
      parents: prevParents,
      aboveElement: aboveElement,
      belowElement: null,
      siblings: siblings
    };
    if (aboveElement) {
      links[aboveElement].belowElement = elementId;
    }
    aboveElement = elementId;
    if (element.isAdult) {
      links[elementId].isAdult = true;
      var children = ignoreDraggedElement(element);
      var childrenIds = children ? children.map(function (child) {
        return child.id;
      }) : [];
      links[elementId].children = childrenIds;
      if (children && children.length > 0) {
        var childParents = [elementId].concat(_toConsumableArray(prevParents));
        children.forEach(function (child) {
          return setLinks(child, childParents, childrenIds);
        });
        links[(0, _last2["default"])(childrenIds)].isLastChild = true;
      }
    }
  }
  var rootChildren = ignoreDraggedElement(tree);
  if (rootChildren && rootChildren.length > 0) {
    var rootChildrenIds = rootChildren.map(function (child) {
      return child.id;
    });
    rootChildren.forEach(function (child) {
      return setLinks(child, [], rootChildrenIds);
    });
    links[(0, _last2["default"])(rootChildrenIds)].isLastChild = true;
  }
  return links;
});
var getAdjustedTree = exports.getAdjustedTree = (0, _reselect.createSelector)(getTree, getDraggedElementId, function (tree, draggedElementId) {
  function getBranch(branch) {
    var parents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    if ((0, _isEmpty2["default"])(branch)) {
      return {};
    }
    var element = (0, _omit2["default"])(branch, ['children']);
    element.parents = parents;
    element.level = level;
    if (branch.children && branch.children.length > 0) {
      if (element.id === draggedElementId) {
        element.children = [];
      } else {
        element.children = branch.children.map(function (child) {
          return getBranch(child, [element.id].concat(_toConsumableArray(parents)), level + 1);
        });
        element.children[element.children.length - 1].isLastChild = true;
      }
    }
    return element;
  }
  return getBranch(tree);
});
var getPlaceholderPosition = exports.getPlaceholderPosition = (0, _reselect.createSelector)(getHoveredElement, getElementLinks, getRootId, getCollapsedElements, function (hoveredElement, links, rootId) {
  var collapsedElements = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  // Helper function
  var getNextPlaceholder = function getNextPlaceholder(elementId) {
    var thisLink = links[elementId];
    var siblings = thisLink.siblings;
    var nextId = siblings[siblings.indexOf(elementId) + 1];
    return {
      placeholderBefore: nextId,
      placeholderParentId: thisLink.parents[0] || rootId
    };
  };
  var id = hoveredElement.id,
    top = hoveredElement.top,
    middle = hoveredElement.middle,
    bottom = hoveredElement.bottom,
    level = hoveredElement.level;
  var nullResult = {
    placeholderBefore: 0,
    placeholderParentId: rootId
  };
  var link = links[id];
  if (!link) {
    return nullResult;
  }
  var diff = Math.max(link.parents.length + 1 - level, -1);
  var isCollapsed = collapsedElements.includes(id);

  // If it's a top hover then move it to the bottom for the previous element
  if (top && (!middle || diff > 0 || !link.isAdult || isCollapsed)) {
    if (link.aboveElement) {
      top = false;
      bottom = true;
      middle = false;
      id = link.aboveElement;
      link = links[id];
      diff = Math.max(link.parents.length + 1 - level, -1);
      isCollapsed = collapsedElements.includes(id);
    } else {
      return {
        placeholderBefore: id,
        placeholderParentId: rootId
      };
    }
  }
  if (link.isAdult && !isCollapsed) {
    // if it's a "folder"
    if (middle && diff <= 0) {
      return {
        placeholderBefore: 0,
        placeholderParentId: id
      };
    }
    if (bottom) {
      if (link.children.length !== 0) {
        return {
          placeholderBefore: link.belowElement,
          placeholderParentId: id
        };
      }
      if (diff === -1) {
        return {
          placeholderBefore: 0,
          placeholderParentId: id
        };
      }
      if (!link.isLastChild) {
        return {
          placeholderBefore: link.belowElement,
          placeholderParentId: link.parents[0] || rootId
        };
      }
      if (diff === 0) {
        return {
          placeholderBefore: 0,
          placeholderParentId: link.parents[0] || rootId
        };
      }
      for (var i = 0; i < diff; i++) {
        var parentId = link.parents[i];
        var parentLink = links[parentId];
        if (!parentLink.isLastChild) {
          return getNextPlaceholder(parentId);
        }
        if (parentLink.isLastChild && i === diff - 1) {
          return {
            placeholderBefore: 0,
            placeholderParentId: parentLink.parents[0] || rootId
          };
        }
      }
    }
  } else if (bottom) {
    // if it's a "node"
    if (!link.isLastChild) {
      return {
        placeholderBefore: link.belowElement,
        placeholderParentId: link.parents[0] || rootId
      };
    }
    if (diff <= 0) {
      return {
        placeholderBefore: 0,
        placeholderParentId: link.parents[0] || rootId
      };
    }
    for (var _i = 0; _i < diff; _i++) {
      var _parentId = link.parents[_i];
      var _parentLink = links[_parentId];
      if (!_parentLink.isLastChild) {
        return getNextPlaceholder(_parentId);
      }
      if (_parentLink.isLastChild && _i === diff - 1) {
        return {
          placeholderBefore: 0,
          placeholderParentId: _parentLink.parents[0] || rootId
        };
      }
    }
  }
  return nullResult;
});
var getFirstElementId = exports.getFirstElementId = (0, _reselect.createSelector)(getElementLinks, function (links) {
  var firstElementId = (0, _findKey2["default"])(links, {
    aboveElement: null
  });
  return firstElementId ? +firstElementId : 0;
});
var getLastElementId = exports.getLastElementId = (0, _reselect.createSelector)(getElementLinks, function (links) {
  var lastElementId = (0, _findKey2["default"])(links, {
    belowElement: null
  });
  return lastElementId ? +lastElementId : 0;
});
var getParentId = exports.getParentId = (0, _reselect.createSelector)(getPlaceholderPosition, function (placeholderPosition) {
  return placeholderPosition.placeholderParentId;
});
var getCanDrop = exports.getCanDrop = (0, _reselect.createSelector)(getElementLinks, getDraggedElement, getParentId, function (links, draggedElement, parentId) {
  var parent = links[parentId] || {};
  if (parent.isChildAllowed && !parent.isChildAllowed(draggedElement.type)) {
    return false;
  }
  if (draggedElement.isParentAllowed && !draggedElement.isParentAllowed(parent.type)) {
    return false;
  }
  return true;
});